export const mockResponses = [
  {
    keywords: ["please help", "please help me", "need help", "help me", "help"],
    linkType: "chips",
    responses: [
      "Please select one of the options below",
    ]
  },
  {
    keywords: ["hello", "hi", "hai", "hey", "good morning", "good afternoon", "good evening"],
    responses: [
      "Hello! 👋 How can I assist you today?",
      "Hi there! What would you like to know?",
      "Hey! I'm your AI assistant. Ask me anything."
    ]
  },
  {
    keywords: ["bye", "goodbye", "see you", "take care"],
    responses: [
      "Goodbye! Have a great day 😊",
      "See you soon!",
      "Take care! 👋"
    ]
  },
  {
    keywords: ["thank you", "thanks", "thank u", "great", "awesome", "perfect", "wonderful"],
    responses: [
      "You're welcome! 😊 Is there anything else I can help you with?",
      "Happy to help! Let me know if you need anything else.",
      "Glad I could assist! Feel free to ask if you have more questions."
    ]
  },
  {
    keywords: ["home", "home page", "homepage", "go to home", "main page"],
    linkType: "home",
    responses: [
      "Here is the TalentFind home page:",
      "Go to the TalentFind home page here:",
    ]
  },
  {
    keywords: ["what is talentfind", "about talentfind", "about", "how it works", "how does it work", "what do you do", "tell me about"],
    linkType: "about",
    responses: [
      "TalentFind helps healthcare professionals manage their career profile, find opportunities and stay ready for what comes next.",
      "TalentFind is a global healthcare careers platform — build your career profile, explore opportunities and access training.",
    ]
  },
  {
    keywords: ["login", "sign in", "sign-in", "log in"],
    linkType: "login",
    responses: [
      "Here is the login page:",
    ]
  },
  {
    keywords: ["register", "sign up", "sign-up", "create account", "new account", "join", "guide me to register", "how to register", "help me register", "registration"],
    linkType: "register",
    responses: [
      "Here is the registration page:",
      "You can create your TalentFind profile here:",
    ]
  },
  {
    keywords: ["password", "reset password", "forgot password", "forgot", "change password", "cant login", "cannot login", "unable to login"],
    linkType: "password",
    responses: [
      "You can reset your password at any time. Here is the link to reset your password:",
      "No worries! Here is the link to reset your password:",
    ]
  },
  {
    keywords: ["profile", "career profile", "career passport", "my profile", "update profile", "edit profile", "build profile", "create profile"],
    linkType: "profile",
    responses: [
      "You can create or update your career profile here:",
      "Your career passport is your central profile on TalentFind. Get started here:",
      "Keep your career profile ready and up to date:",
    ]
  },
  {
    keywords: ["cv", "resume", "upload cv", "my cv", "create cv", "cv builder", "curriculum vitae"],
    linkType: "profile",
    responses: [
      "You can upload your CV and build your career profile here:",
      "Add your CV to your TalentFind profile:",
    ]
  },
  {
    keywords: ["jobs", "job search", "find jobs", "browse jobs", "vacancies", "opportunities", "open roles", "positions", "job openings"],
    linkType: "jobs",
    responses: [
      "Explore healthcare job opportunities here:",
      "Browse available roles and opportunities:",
      "Find your next healthcare role here:",
    ]
  },
  {
    keywords: ["documents", "upload documents", "my documents", "certificates", "upload certificate", "qualifications", "credentials"],
    linkType: "profile",
    responses: [
      "You can upload and manage your documents through your career profile:",
      "Keep your documents and certificates ready in your TalentFind profile:",
    ]
  },
  {
    keywords: ["training", "cpd", "courses", "upskilling", "learning", "development", "skill", "skills"],
    linkType: "training",
    responses: [
      "Explore training and professional development opportunities:",
      "Access CPD and upskilling resources here:",
      "Find courses and training relevant to your healthcare career:",
    ]
  },
  {
    keywords: ["international", "work abroad", "relocation", "overseas", "global", "migrate", "move abroad", "international jobs", "work overseas"],
    linkType: "career",
    responses: [
      "Explore international healthcare career pathways here:",
      "TalentFind connects professionals to global healthcare opportunities. Explore here:",
    ]
  },
  {
    keywords: ["ielts", "oet", "language test", "english test", "language requirement", "language", "english"],
    linkType: "training",
    responses: [
      "Language preparation is an important step for international healthcare careers. Find resources here:",
      "Explore language and upskilling support here:",
    ]
  },
  {
    keywords: ["career pathway", "pathway", "career plan", "career goals", "career guidance", "next step", "career development"],
    linkType: "career",
    responses: [
      "Explore your healthcare career pathway here:",
      "Plan your next career step with TalentFind:",
    ]
  },
  {
    keywords: ["news", "articles", "blog", "latest", "updates", "latest articles", "read"],
    linkType: "news",
    responses: [
      "Stay up to date with the latest healthcare career insights:",
      "Read the latest articles and news here:",
    ]
  },
  {
    keywords: ["account", "my account", "account settings", "settings", "delete account", "manage account"],
    linkType: "support",
    responses: [
      "For account-related queries, please contact our support team at:",
    ]
  },
  {
    keywords: ["verify", "verification", "verify account", "confirm email", "email confirmation", "activate account"],
    linkType: "support",
    responses: [
      "For verification issues, please reach out to our support team at:",
      "Need help with account verification? Contact us at:",
    ]
  },
  {
    keywords: ["support", "contact", "contact us", "assist", "assistance", "query", "queries", "issue", "problem", "trouble", "email"],
    linkType: "support",
    responses: [
      "For any queries or assistance, please write to us at:",
      "You can reach our support team at:",
      "Need help? Contact us at:",
    ]
  },
];

